module.exports = __webpack_public_path__ + "static/media/FlowDesign.dc5f0051.svg";